import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom";
import {
  getSideBarfilesActions,
  setThecountBasedRenders,
  setTheoptions,
  setGrievanceEMPListAction,
  ////--filters
  setRegionActions,
  setZoneActions,
  setGeoLoactionStateAction,

  setTheGrievance_ListState,
  setTheGrievance_ListRegion,
  setTheGrievance_ListZone,

setheGrievance_ListdesignationStatus,
setTheGrievance_ListStateStatus,
setTheGrievance_ListRange1,
setTheGrievance_ListRange2,
setGrievanceEMPexportAction,
setTablePositionPersist

} from "../../../Redux/Slice";
import correctIcons from "../../../Assets/AppComponent/icons/Group 359.svg";
import Pendingimg from "../../../Assets/AppComponent/icons/Group 145.svg";
import ReactTable from "../../AppComponent/Table";
import Select from "react-select";
import GrievaceApprove from "./GrievaceApprove";
import { DateRangePicker, Stack } from "rsuite";
import subDays from "date-fns/subDays";
import startOfWeek from "date-fns/startOfWeek";
import endOfWeek from "date-fns/endOfWeek";
import addDays from "date-fns/addDays";
import "rsuite/dist/rsuite.css";
import isAfter from "date-fns/isAfter";
import { differenceInDays } from "date-fns";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import _ from "lodash";
import EditImages from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-04 (1).svg";
import useDebouncedEffect from 'use-debounced-effect';

const GrievanceEmployeeList = () => {
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
        const TablePositionPersist = useSelector(state=>state.PreviousPagePosition.TablePositionPersist)
  
  const UserObjectData = useSelector((state) => state.users.UserData);

  const state = useSelector((state) => state);
  const dispatch = useDispatch();
  const [EditID, setEditId] = useState();
  const [dtpageindex, setdtPageindex] = useState(TablePositionPersist?.GrievanceEmployeetab?.page==undefined?1:TablePositionPersist.GrievanceEmployeetab.page);
  const [dtpagesize, setdtPagesize] = useState(10);
  const [pageSize, setPageSize] = useState(20);
  const [newpages, setNewpage] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setsearch] = useState(TablePositionPersist?.GrievanceEmployeetab?.search == "" || TablePositionPersist?.GrievanceEmployeetab?.search ==undefined? "":TablePositionPersist.GrievanceEmployeetab.search);
  const [EmployeePop, setEmployeePop] = useState(false);
  const [EmployeeIDs, setEmployeeIDs] = useState();

  ///---filter for white collar--------
  const [EmpRoles, setEmplyeRole] = useState([
    {
      value: "",
      label: "ALL",
    },
    {
      value: "1",
      label: "UDS",
    },
    {
      value: "2",
      label: "CLIENT",
    },
  ]);

  var today = new Date();
  var priorDate = new Date(new Date().setDate(today.getDate() - 30));
  var it = convert(state.StateManagementOverallCall.Grievance_ListRange1);
  var gt = convert(state.StateManagementOverallCall.Grievance_ListRange2);
  const [range, setrange] = useState(
    state.StateManagementOverallCall.Grievance_ListRange1 == ""
      ? // [it, gt]
        []
      : [it, gt]
  );



  function convert(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }

  //----Handle----Date=-----Changes---
  const handlechangedate = (value) => {
    if (value != null) {
      setrange((oldArray) => [...oldArray, value.slice(0, 10)]);
    }
  };
  const [filterForWhite, setFilters] = useState({ white_collar: 

    state.StateManagementOverallCall.Grievance_Listdesignation?.value == ""?
    "":
    state.StateManagementOverallCall.Grievance_Listdesignation?.value == 1 ?
    true:
    false



   });


   useEffect(() => {
    if (range.length > 0 && !range.includes("NaN-aN-aN")) {
      dispatch(setTheGrievance_ListRange1(range[0]));
      dispatch(setTheGrievance_ListRange2(range[1]));
    }
  }, [range]);


  const HandleEMprole = (e) => {
    setdtPageindex(1);
    if (e != null) {
      dispatch(setheGrievance_ListdesignationStatus(e))
     setdtPageindex(1);

     if (e.value == 1) {
       setFilters({
         ...filterForWhite,
         white_collar: true,
       });
     } else if (e.value == 2) {
       setFilters({
         ...filterForWhite,
         white_collar: false,
       });
     } else if (e.value == "") {
       setFilters({
         ...filterForWhite,
         white_collar: "",
       });
       dispatch(setheGrievance_ListdesignationStatus({value:"",label:"All"}))
     }
   }

  };

  const FileterState = {
    status: state.StateManagementOverallCall.setTheGrievance_ListStateStatus?.value,
  };
  const [selectDisplay, setDisplay] = useState([]);
  const [selectVal, SetSelectval] = useState(FileterState);
  const [FState, SetStates] = useState(false);
  ////--_FIlter--------------------------
  const [Filter, SetFilter] = useState(true);
  const options = [
    { value: "", label: "All" },
    { value: "pending", label: "Open" },
    { value: "inprogress ", label: "In-Progress" },
    { value: "decline", label: "Decline" },
    { value: "approved", label: "Closed" },
  ];
  const [place, SetPlace] = useState("All");
  const [sel, setSelected] = useState();
  ///--filter----------------
  let [nameList, setOptions] = useState([]);
  const [nameList2, setOptions2] = useState([]);
  const [REgion, setRegion] = useState([]);
  const [multiselect1, setMuliselect1] = useState(
    state.StateManagementOverallCall.Grievance_ListRegion
  );
  const [multiselect3, setMuliselect3] = useState(
    state.StateManagementOverallCall.Grievance_ListZone
  );
  const [nameList4, setOptions4] = useState([]);
  const [Zone, setZone] = useState([]);
  const [data, setData] = useState({ 
    zone: state.StateManagementOverallCall.Grievance_ListZone?.value,
     state: state.StateManagementOverallCall.Grievance_ListState?.value,
      region: state.StateManagementOverallCall.Grievance_ListRegion?.value
     });
  const [multiselect, setMuliselect] = useState([
    //  { value: "", label: "All" }
    state.StateManagementOverallCall.Grievance_ListState,
  ]);


  //--------Place---Holder----dispatch======

  ///--Grievance-----List

  useEffect(() => {
    if (range.length > 0 && !range.includes("NaN-aN-aN")) {
      const payload = {
      search: search,
      page_size: 20,
      page: dtpageindex,
      selectVal: selectVal,
      data: data,
      white_collar: filterForWhite.white_collar,
      // month: Datestate.month,
      // year: Datestate.year,
      // date: Datestate.date,
      from_date: range[0],

      to_date: range[1],
    };
    dispatch(setGrievanceEMPListAction(payload));
    dispatch(setTablePositionPersist({data:payload,pageName:"GrievanceEmployeetab"}))
  }
  }, [data, selectVal, filterForWhite, range, dtpageindex ,search]);

  
  ///----filter-----
  const initialStateSearch = {
    stateSearch: "",
    regionSearch: "",
    zoneSearch: "",
  };
  const [SearchedVal, setSearched] = useState(initialStateSearch);

  const initialDebouanceSearch = {
    stateSearch: "",
    regionSearch: "",
    zoneSearch: "",
};

const [SearchDebounance, setSearchDebounance] = useState(initialDebouanceSearch);

  ///--------------State-----------------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.stateSearch,
      page_size: "",
      page: 1,
    };
    dispatch(setGeoLoactionStateAction(payloads));
  }, [SearchedVal.stateSearch]);
  //--------------_Zone---------------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.zoneSearch,
      page_size: 20,
      page: currentPage,
      counts: 1,
      region_id: data.region,
    };
    dispatch(setZoneActions(payloads));
    setZone(state.ZonePart.Zone);
  }, [data.region, SearchedVal.zoneSearch]);
  //-----Region---------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.regionSearch,
      page_size: 20,
      page: currentPage,
      counts: 1, //-----only we ----get----the----selected regions , the--id only
      state: data.state,
    };
    dispatch(setRegionActions(payloads));
    //console.log(State.regioncall.RegionDat, "states", State.regioncall.Total_Count);
    setRegion(state.regioncall.RegionDat);
  }, [data.state, SearchedVal.regionSearch]);
  useEffect(() => {
    const Datas = [];
    if (state.GeoState.State != undefined) {
      let objectArray = [];
      objectArray.push({ value: "", label:"ALL" });

      state.GeoState.State.forEach((element) => {
        objectArray.push({ value: element.id, label: element.state_name.toUpperCase() });
      });
      setOptions(objectArray);
    }
  }, [state.GeoState.State, SearchedVal.stateSearch]);
  ///  ///----------------------REgion-----------
  useEffect(() => {
    const Datas = [];
    setRegion(state.regioncall.RegionDat);
    if (state.regioncall.RegionDat != undefined) {
      let objectArray = [];
      state.regioncall.RegionDat.forEach((element) => {
        objectArray.push({ value: element.id, label: element.region_name.toUpperCase() });
      });
      setOptions2(objectArray);
    }
  }, [state.regioncall.RegionDat, SearchedVal.regionSearch]);
  //----Region----------------
  const handelRegionSlect = (selectedVal) => {
    if (selectedVal != null) {
      dispatch(setTheGrievance_ListRegion(selectedVal))
      dispatch(setTheGrievance_ListZone({ value: "", label: "ALL" }))


      setMuliselect1(selectedVal);
      setData({
        ...data,
        region: selectedVal.value,
      });
    }
    if (selectedVal == null) {
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });
      dispatch(setTheGrievance_ListRegion({ value: "", label: "ALL" }))
      dispatch(setTheGrievance_ListZone({ value: "", label: "ALL" }))


      setData({
        ...data,
        region: "",
        zone: "",
      });
    }
  };
  //----------------Zone
  const handleZone = (selectedVal) => {
    //console.log(selectedVal ,"selected Values");
    if (selectedVal != null) {
      setMuliselect3(selectedVal);
      dispatch(setTheGrievance_ListZone(selectedVal))


      setData({
        ...data,
        zone: selectedVal.value,
      });
    }
    if (selectedVal == null) {
      dispatch(setTheGrievance_ListZone({ value: "", label: "ALL" }))
      setMuliselect3({ value: "", label: "ALL" });


      setData({
        ...data,
        zone: "",
      });
    }
  };
  const handleSelectChange = (selectedVal) => {
    console.log(selectedVal, "selectedval");
    if (selectedVal != null) {
      setMuliselect(selectedVal);
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });

      dispatch(setTheGrievance_ListState(selectedVal));
      dispatch(setTheGrievance_ListRegion({ value: "", label: "ALL" }))
      dispatch(setTheGrievance_ListZone({ value: "", label: "ALL" }))




      setData({
        ...data,
        state: selectedVal.value,
        region: "",
        zone: "",
      });
    }
    if (selectedVal == null) {
      setMuliselect({ value: "", label: "ALL" });
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });
      dispatch(setTheGrievance_ListState({value:"",label:"ALL"}));
      dispatch(setTheGrievance_ListRegion({ value: "", label: "ALL" }))
      dispatch(setTheGrievance_ListZone({ value: "", label: "ALL" }))



      setData({
        ...data,
        state: "",
        region: "",
        zone: "",
      });
    }
  };
  ///-------------Zone--------------
  useEffect(() => {
    const Datas = [];
    setZone(state.ZonePart.Zone);
    if (state.ZonePart.Zone != undefined) {
      let objectArray = [];
      state.ZonePart.Zone.forEach((element) => {
        objectArray.push({ value: element.id, label: element.zone_name.toUpperCase() });
      });
      setOptions4(objectArray);
    }
  }, [state.ZonePart.Zone, SearchedVal.zoneSearch]);
 ///-----State----Input Changes
 const handleInputChange = (Val) => {
  setSearchDebounance({
      ...SearchDebounance,
      stateSearch: Val,

  });

};

///---Region-----------------
const handleInputRegion = (Val) => {
  setSearchDebounance({
      ...SearchDebounance,
      regionSearch: Val,
  });
};
///----Zone---Name
const handleInputZone = (Val) => {
  setSearchDebounance({
      ...SearchDebounance,
      zoneSearch: Val,
  });
};

useDebouncedEffect(
() => {
    if (setSearchDebounance) {
        setSearched({
            ...SearchedVal,
            stateSearch: SearchDebounance.stateSearch,
            regionSearch: SearchDebounance.regionSearch,
            zoneSearch: SearchDebounance.zoneSearch,
        });

    }
},
500,
[SearchDebounance]
);
  //--------_____Filter-----------Based---On----Status--
  const count = (Counts, values, sel, SelectedValues) => {
    setDisplay(SelectedValues);
    setSelected(sel);
    SetStates(true);
    setdtPageindex(1);

    

    dispatch(setTheGrievance_ListStateStatus(SelectedValues));
    if (values == "Open") {
      ///Pending
      SetSelectval({
        ...selectVal,
        status: "pending",
      });
    } else if (values == "Decline") {
      //Decline
      SetSelectval({
        ...selectVal,
        status: "decline",
      });
    }
    else if (values == "In-Progress") {
      //Decline
      SetSelectval({
        ...selectVal,
        status: "inprogress ",
      });
    }
    else if (values == "Closed") {
      //Approve
      SetSelectval({
        ...selectVal,
        status: "approved",
      });
    } else if (values == "ALL") {
      //Approve
      SetSelectval({
        ...selectVal,
        status: "",
      });
    }
    else if (values == "All") {
      //Approve
      SetSelectval({
        ...selectVal,
        status: "",
      });
    }
  };
  //--------Place---Holder----dispatch======
  const ClearState = (Counts) => {
    if (Counts == 2) {
      SetSelectval({
        ...selectVal,
        status: "",
      });
      setdtPageindex(1);
      dispatch(setTheGrievance_ListStateStatus({value:"",label:"ALL"}));

    }
  };
  const pagesize = (arg) => {
    setdtPagesize(arg);
  };
  const pageindex = (arg) => {
    //  console.log(arg, "args");
    setdtPageindex(arg);
  };
  const handleNext = (next) => {    
    setdtPageindex(next + 1);
};

const GotoEnteredPage =(gotopage)=>{
 setdtPageindex(gotopage)
}

const handlePrevious = (previous) => {
if (previous != 0) {
  setdtPageindex(previous);

}
};


  // -----Search------------------------
  function tochange(e) {
    setdtPageindex(1);
    debouncedSearch(e);

  }
  const debouncedSearch = useMemo(
    () =>
      _.debounce((e) => {
        setsearch(e);
      }, 500),
    []
  );
  React.useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);


  const capitalizeFirstLetter = (Letter) => {
    return Letter.charAt(0).toUpperCase() + Letter.slice(1);
  };

  const truncate = (text, len = 25) =>
  text && text.length > len ? text.slice(0, len) + "..." : text;

  const columns = [
    {
      Header: "Name",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.user_id.first_name ? (
              <span>{row.row.original.user_id.first_name}</span>
            ) : (
              <span>---</span>
            )}
          </>
        );
      },
    },
    {
      Header: "CATEGORY",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.grievance_type.grievance_type != null ? (
              <span>{row.row.original.grievance_type.grievance_type}</span>
            ) : (
              <span>----</span>
            )}
          </>
        );
      },
    },
{
  Header: "Purpose",
  accessor: "purpose",
  Cell: ({ row }) => (
    <span title={row.original.purpose}>
      {truncate(row.original.purpose) || "----"}
    </span>
  ),
},


    {
      Header: "Created Date",
      accessor: "",
      Cell: (row) => {
        const dateString = row.row.original.created_at;
        const dateObject = new Date(dateString);
        const hours = dateObject.getHours();
        const minutes = dateObject.getMinutes();
        const seconds = dateObject.getSeconds();
        const amOrPm = hours >= 12 ? "PM" : "AM";
        const twelveHourFormat = hours % 12 || 12;

        const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

        const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;

        return (
          <>
            <span>
              {`${
                row.row.original.created_at.slice(0, 10) + "  " + formattedTime
              }`}
            </span>
          </>
        );
      },
    },
    {
      Header: "Status",
      accessor: "status",
      Cell: (row) => {
        const originalString = row.row.original.status;
        const capitalizedString = capitalizeFirstLetter(originalString);
        return (
          <>
            {row.row.original.status != undefined ? (
              <>
                {row.row.original.status.toLowerCase() == "pending" ? (
                  <div className="StatusList">
                    <img src={Pendingimg} />
                    <span>{"Open"}</span>
                  </div>
                ) : (
                  <>
                    {row.row.original.status.toLowerCase() == "decline" ? (
                      <div className="StatusList">
                        <div className="DeclineStatus">
                          <span>x</span>
                        </div>
                        <span>{"Decline"}</span>
                      </div>
                    ) : (
                      <>
                        {row.row.original.status.toLowerCase() == "approved" ? (
                          <div className="StatusList">
                            <img src={correctIcons} />
                            <span>{"Closed"}</span>
                          </div>
                        ) : 
                        <>
                        {
                          row.row.original.status.toLowerCase() == "inprogress" ? (
                          <div className="StatusList">
                            <img src={Pendingimg} />
                            <span>{"In-Progress"}</span>
                          </div>
                          ):null
                        }


                        </>
                        }
                      </>
                    )}
                  </>
                )}
              </>
            ) : (
              <span>---</span>
            )}
          </>
        );
      },
    },

    {
      Header: "Action",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <div
              class="actions"
              style={{
                display: "flex",
                justifyContent: "flex-start",
                gap: "5px",
              }}
            >
              <button
                className=" btn Status"
                component="span"
                onClick={(e) => {
                  setEmployeePop(true);
                  setEmployeeIDs(row.row.original.id);
                }}
              >
                <span className="OuterActionSpan">
                  {/* <i
                    class="fa-solid fa-pen"
                    style={{ fontSize: "14px", paddingRight: "3px", paddingBottom:"3px" }}
                  ></i> */}
                                    <span  className="EditImages">
                    <img src={EditImages}/>
                  </span>
                  <span className="ActionsList"> Edit </span>
                </span>
              </button>
            </div>
          </>
        );
      },
    },
  ];

  const cleaningrange = () => {
    //setrange([gt,it]);
  };

  const predefinedBottomRanges = [
    {
      label: "Today",
      value: [new Date(), new Date()],
      placement: "left",
    },
    {
      label: "Yesterday",
      value: [addDays(new Date(), -1), addDays(new Date(), -1)],
      placement: "left",
    },
    {
      label: "This week",
      value: [startOfWeek(new Date()), endOfWeek(new Date())],
      placement: "left",
    },
    {
      label: "Last week",
      value: (value, index) => {
        const [start = new Date()] = value[index] || [];
        return [
          addDays(startOfWeek(start, { weekStartsOn: 0 }), -7),
          addDays(endOfWeek(start, { weekStartsOn: 0 }), -7),
        ];
      },
      placement: "left",
    },
    {
      label: "Last 30 days",
      value: [subDays(new Date(), 29), new Date()],
      placement: "left",
    },
  ];


  const openMe = ()=>{
    const rsAnimFade = document.querySelector('.rs-anim-fade');
    if (rsAnimFade) {
      rsAnimFade.style.setProperty('left', '1085.34px', 'important');
      rsAnimFade.style.setProperty('top', '186.109px', 'important');   
    }
   }
  
   const CloseDateRange = ()=>{
    const rsAnimFade = document.querySelector('.rs-anim-fade');
    if (rsAnimFade) {
      rsAnimFade.style.setProperty('display', 'none', 'important');
      // rsAnimFade.style.setProperty('top', '184.109px', 'important');   
    }
   }


 const HandleTheExports =()=>{
  
  if(range.length > 0 && !range.includes("NaN-aN-aN")){
    const payload = {
      sheet: true,
            from_date: range[0],

      to_date: range[1],
      range:true ,
          zone: data.zone,
          state: data.state,
          region: data.region,
                status: selectVal?.status,
      white_collar: filterForWhite.white_collar,


      
    };
    dispatch(setGrievanceEMPexportAction(payload));
  }

 }
  return (
    <>
      <div className={stateDisplay ? "outterContent" : "inner-Content"}>
        <div
          className="Header-Details ClientBranch row"
          style={{ padding: "14px 28px" }}
        >
          <div
            class="col-sm-7 auto"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "flex-start",
            }}
          >
            <h3>Grievance List</h3>
         
          </div>
        </div>


        <div
          className="row Filters"
          style={{
            padding: "15px 28px",
            margin: "0px",
            position: "relative",
            zIndex: "90",
               
            marginLeft: "0px",
            marginRight: "0px",
            top: "-30px",
          }}
        >
          <div className="col ">
            <label for="validationCustom01" class="form-label">
              State 
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => {
                setMuliselect(e);
              }}
              onChange={(e) => {
                setdtPageindex(1);
                handleSelectChange(e);
              }}
              options={nameList}
              onInputChange={handleInputChange}
              onremoved={(e) => {
                setMuliselect(e);
                console.log(e, "jjk9090");
              }}
              labelledBy="Select"
              placeholder={"Search"}
              value={multiselect}
            />
          </div>
          <div className="col ">
            <label for="validationCustom01" class="form-label">
              Region 
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => setMuliselect1(e)}
              onChange={(e) => {
                setdtPageindex(1);

                handelRegionSlect(e);
              }}
              options={nameList2}
              labelledBy="Select"
              isClearable={true}
              onremoved={(e) => {
                setMuliselect1(e);
              }}
              onInputChange={handleInputRegion}
              placeholder={"Search"}
              value={multiselect1}
            />
            
          </div>
          <div className="col ">
            <label for="validationCustom01" class="form-label">
              Zone 
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => setMuliselect3(e)}
              onChange={(e) => {
                setdtPageindex(1);

                handleZone(e);
              }}
              options={nameList4}
              isClearable={true}
              onremoved={(e) => {
                setMuliselect3(e);
                console.log(e, "jjk9090");
              }}
              labelledBy="Select"
              onInputChange={handleInputZone}
              placeholder={"Search"}
               value={multiselect3}
            />
          </div>

          <div className="col-3">
            <label
              for="validationCustom01"
              class="form-label"
              style={{ marginBottom: "11px" }}
            >
              {/* State Name */}
              Select Date
              <span style={{ color: "red" }}>*</span>

            </label>

            <div className="datepicker_dash" style={{ marginTop: "-5px" }}>
              <DateRangePicker
defaultValue={
  state.StateManagementOverallCall.Grievance_ListRange1 == ""
    ? []
    : [
        new Date(
          state.StateManagementOverallCall.Grievance_ListRange1
        ),
        new Date(
          state.StateManagementOverallCall.Grievance_ListRange2
        ),
      ]
}
onOpen={() => {
  openMe()
}}
onClose={() => {
CloseDateRange()
   }}
                disabledDate={(date) => isAfter(date, new Date())}
                editable={false}
                appearance="default"
                placement="bottomEnd"
                size="lg"
                ranges={predefinedBottomRanges}
                placeholder="From - To"
                // style={{ width: 270, padding: 10 }}
                onClean={(e) => cleaningrange(e)}
                onChange={(e) => {
                  if (e != null && e.length === 2) {
                    const [startDate, endDate] = e;
                    const diffDays = differenceInDays(endDate, startDate);
                    // if (diffDays === 30) {
                    //   // Since we are using inclusive range, difference should be 30 for 31 days
                    //   setrange([]);
                    //   e.forEach((newValue) => {
                    //     const tzoffset = new Date().getTimezoneOffset() * 60000; // offset in milliseconds
                    //     const localISOTime = new Date(newValue - tzoffset)
                    //       .toISOString()
                    //       .slice(0, -1);
                    //     handlechangedate(localISOTime);
                    //   });
                    // } else if (diffDays < 30) {
                    //   setrange([]);
                    //   e.forEach((newValue) => {
                    //     const tzoffset = new Date().getTimezoneOffset() * 60000; // offset in milliseconds
                    //     const localISOTime = new Date(newValue - tzoffset)
                    //       .toISOString()
                    //       .slice(0, -1);
                    //     handlechangedate(localISOTime);
                    //   });
                    // } else {
                    //   toast.error("Please select a range of exactly 31 days.", {
                    //     position: toast.POSITION.TOP_RIGHT,
                    //   });
                    // }

                    setrange([]);
                    e.forEach((newValue) => {
                      const tzoffset = new Date().getTimezoneOffset() * 60000; // offset in milliseconds
                      const localISOTime = new Date(newValue - tzoffset)
                        .toISOString()
                        .slice(0, -1);
                      handlechangedate(localISOTime);
                    });
                  }
                }}
              />
            </div>
          </div>
          {range.length > 0 && !range.includes("NaN-aN-aN") && (

       

                                          <div className=""  style={{display:"flex", justifyContent:"end",alignItems:"center"}}>
                                    <button
                                        align="center"
                                        type="button"
                                        style={{
                                            display: "flex",
                                            justifyContent: "flex-end",
                                            background: "transparent",
                                        }}
                                        className="DownloadBTNS"
                                        onClick={(e) => {
                                            HandleTheExports()
                                        }}
                                    >
                                        <a class="dnbtn"></a>
                                    </button>

                                </div>

   )}
        </div>
        <div style={{ padding: " 0px 40px", marginTop: "-13px" }}>
          <ReactTable
            data={state.grievanceEMpListCall.grievanceListDatas}
            columns={columns}
            totalItems={state.grievanceEMpListCall.Total_Count}
            currentPage={currentPage}
            onChange={tochange}
            setCurrentPage={setCurrentPage}
            pagesize={pagesize}
            onPrevious={handlePrevious}
            onNextpage={handleNext}
            GotoEnteredPage={GotoEnteredPage}
          dtpagesize={pageSize}
            dtpageindex={dtpageindex}
            pageindex={pageindex}
            datacount={state.grievanceEMpListCall.Total_Count}
            value={state.NumberCounts.Options}
            options={options}
            Filter={Filter}
            count={count}
            ClearState={ClearState}
            placeHold={place}
            ///--- emoloyee role based filters -
            EmployeeRoleTrue={true}
            EmployeeRoleOption={EmpRoles}
            EMpROleSelected={state.StateManagementOverallCall.Grievance_Listdesignation}
            HandleEMprole={HandleEMprole}
            ApproveRequestFilter={true}
                   searchVal={TablePositionPersist?.GrievanceEmployeetab?.search == "" || TablePositionPersist?.GrievanceEmployeetab?.search ==undefined? "":TablePositionPersist.GrievanceEmployeetab.search}
              search_key={true}

          />
        </div>
      </div>
      <>
        {EmployeePop && EmployeeIDs != undefined && selectVal ? (
          <GrievaceApprove
            show={EmployeeIDs}
            setShow={setEmployeePop}
            currentPage={dtpageindex}
            EditId={EmployeeIDs}
            selectVal={selectVal}
            from_date={range[0]}
            to_date={range[1]}
            data={data}
            white_collar={filterForWhite.white_collar}
            search={search}
          />
        ) : null}
      </>
    </>
  );
};

export default GrievanceEmployeeList;
